import React from "react";

export const EventChartTable = ({ data, activeTab }) => {
  const uniqueAgencies = [
    ...new Set(
      data.flatMap((company) => company.agencies.map((agency) => agency.name))
    ),
  ];

  uniqueAgencies.sort((a, b) => a.localeCompare(b));

  const grandTotalRow = {
    "Company Name": "Grand Total",
  };

  data.forEach((company) => {
    company.agencies.forEach((agency) => {
      grandTotalRow[agency.name] =
        (grandTotalRow[agency.name] || 0) + parseFloat(agency.totalBilling);
    });
  });

  const grandTotal = Object.values(grandTotalRow)
    .slice(1)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);

  const formatValue = (value) => {
    if (value % 1 === 0) {
      return value; 
    }
    return value.toFixed(2);
  };

  return (
    <div style={{ width: "inherit", overflow: "auto" }}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th
              style={
                activeTab === "event"
                  ? tableEventHeaderStyle
                  : activeTab === "mice" && tableMICEHeaderStyle
              }
            >
              Name of ABG Business
            </th>
            {uniqueAgencies.map((agency, index) => (
              <th
                key={index}
                style={
                  activeTab === "event"
                    ? tableEventHeaderStyle
                    : activeTab === "mice" && tableMICEHeaderStyle
                }
              >
                {agency}
              </th>
            ))}
            <th
              style={
                activeTab === "event"
                  ? tableEventHeaderStyle
                  : activeTab === "mice" && tableMICEHeaderStyle
              }
            >
              Grand Total
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((company, index) => (
            <tr key={index}>
              <td style={tableDataStyle}>{company.companyName}</td>
              {uniqueAgencies.map((agency, idx) => (
                <td key={idx} style={tableDataStyle}>
                  {formatValue(
                    parseFloat(
                      company.agencies.find((a) => a.name === agency)
                        ?.totalBilling
                    ) || 0
                  )}
                </td>
              ))}
              <td style={tableDataStyle}>
                {formatValue(
                  company.agencies.reduce(
                    (acc, curr) => acc + parseFloat(curr.totalBilling),
                    0
                  )
                )}
              </td>
            </tr>
          ))}
          <tr>
            <td style={tableDataStyle}>{grandTotalRow["Company Name"]}</td>
            {uniqueAgencies.map((agency, index) => (
              <td key={index} style={tableDataStyle}>
                {formatValue(parseFloat(grandTotalRow[agency]) || 0)}
              </td>
            ))}
            <td style={tableDataStyle}>{formatValue(grandTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  border: "1px solid black",
};

const tableEventHeaderStyle = {
  border: "1px solid black",
  padding: "8px",
  textAlign: "center",
  fontWeight: "normal",
  backgroundColor: "#6ccbf1",
};

const tableMICEHeaderStyle = {
  border: "1px solid black",
  padding: "8px",
  textAlign: "center",
  backgroundColor: "#96c01b",
  fontWeight: "normal",
};

const tableDataStyle = {
  border: "1px solid black",
  padding: "8px",
  textAlign: "center",
  backgroundColor: "#e7e7e7",
};

export const MICEChartTable = ({ data }) => {
  const uniqueAgencies = [
    ...new Set(
      data.flatMap((company) => company.agencies.map((agency) => agency.name))
    ),
  ];

  uniqueAgencies.sort((a, b) => a.localeCompare(b));

  const grandTotalRow = {
    "Company Name": "Grand Total",
  };

  data.forEach((company) => {
    company.agencies.forEach((agency) => {
      grandTotalRow[agency.name] =
        (grandTotalRow[agency.name] || 0) + parseFloat(agency.totalBilling);
    });
  });

  const grandTotal = Object.values(grandTotalRow)
    .slice(1)
    .reduce((acc, curr) => acc + parseFloat(curr), 0);

  const formatValue = (value) => {
    if (value % 1 === 0) {
      return value; 
    }
    return value.toFixed(2);
  };

  return (
    <div style={{ width: "inherit", overflow: "auto" }}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableMICEHeaderStyle}>MICE Agency</th>
            {data.map((company) => (
              <th key={company.companyName} style={tableMICEHeaderStyle}>
                {company.companyName}
              </th>
            ))}
            <th style={tableMICEHeaderStyle}>Grand Total</th>
          </tr>
        </thead>
        <tbody>
          {uniqueAgencies.map((agency, index) => (
            <tr key={index}>
              <td style={tableDataStyle}>{agency}</td>
              {data.map((company, idx) => (
                <td key={idx} style={tableDataStyle}>
                  {formatValue(
                    parseFloat(
                      company.agencies.find((a) => a.name === agency)
                        ?.totalBilling
                    ) || 0
                  )}
                </td>
              ))}
              <td style={tableDataStyle}>
                {formatValue(
                  Object.keys(grandTotalRow).includes(agency)
                    ? parseFloat(grandTotalRow[agency])
                    : 0
                )}
              </td>
            </tr>
          ))}
          <tr>
            <td style={tableDataStyle}>Grand Total</td>
            {data.map((company, idx) => (
              <td key={idx} style={tableDataStyle}>
                {formatValue(
                  company.agencies.reduce(
                    (acc, curr) => acc + parseFloat(curr.totalBilling),
                    0
                  )
                )}
              </td>
            ))}
            <td style={tableDataStyle}>{formatValue(grandTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
